import Dialog from 'presentations/views/components/atoms/Dialog';
import DialogSubmitField from 'presentations/views/components/molecules/DialogSubmitField';
import SplashAnimation from 'presentations/views/components/atoms/SplashAnimation';
import Image from 'presentations/views/components/atoms/Image';
import Headline from 'presentations/views/components/atoms/Headline';

import styled from '@emotion/styled';
import { mediaMax, spacing } from 'presentations/views/styles';
import { gray04, gray05 } from 'presentations/views/styles/color';

interface Props {
  isOpen: boolean;
  onClose?: () => void;
  onSubmit?: () => void;
  onCancel?: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  title: string;
  description: string;
  image?: string | null;
}

export default function Component(props: Props) {
  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={props.onClose}
      maxHeight={'800px'}
      actions={
        <DialogSubmitField
          onSubmit={props.onSubmit}
          onCancel={props.onCancel}
          submitLabel={props.submitLabel}
          cancelLabel={props.cancelLabel}
        />
      }
    >
      <Block>
        <TourHeadline variant="h1">{props.title}</TourHeadline>
        <TourDescription>{props.description}</TourDescription>
        <AppImageWrap>
          <Splash />
          {props.image}
          <AppImage
            alt={props.title}
            src="pages/onboard/cracker.svg"
            width={80}
          />
        </AppImageWrap>
      </Block>
    </Dialog>
  );
}

const Block = styled.div`
  position: relative;
`;
const Splash = styled(SplashAnimation)`
  position: absolute;
  left: 50%;
  top: 50%;
`;
const AppImageWrap = styled.div`
  border-bottom: 1px solid ${gray04};
  text-align: center;
  margin-bottom: ${spacing(48)};
`;
const AppImage = styled(Image)`
  margin: ${spacing(24)} 0;
  ${mediaMax.tablet} {
    margin: ${spacing(40)} 0;
  }
`;
const TourHeadline = styled(Headline)`
  text-align: center;
  margin-bottom: ${spacing(16)};
`;
const TourDescription = styled.p`
  text-align: center;
  max-width: 420px;
  margin: 0 auto;
  white-space: pre-wrap;
`;
